/**
 * v-permission 按钮权限指令（add-auth-login）。
 *
 * 用法：`v-permission="'payment.void'"` —— 无权限时移除元素（隐藏）。
 * 权限判定基于 Pinia auth store 的 hasPermission（admin 通配）。
 */
import type { Directive, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth'

export const vPermission: Directive<HTMLElement, string> = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const code = binding.value
    if (!code) return
    const auth = useAuthStore()
    if (!auth.hasPermission(code)) {
      el.parentNode?.removeChild(el)
    }
  },
}
